var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
import { getShape, getColor, getBackgroundColor, getBorderColor } from '../util';
const SvgCar = _a => {
  var {
      size,
      shape = 'circle',
      neutral = false
    } = _a,
    props = __rest(_a, ["size", "shape", "neutral"]);
  const backgroundColor = getBackgroundColor(shape, neutral);
  const color = getColor(shape, neutral);
  const borderColor = getBorderColor(neutral);
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: size !== null && size !== void 0 ? size : 96,
    height: size !== null && size !== void 0 ? size : 96,
    fill: "none",
    viewBox: "0 0 96 96"
  }, props), getShape(shape, backgroundColor), React.createElement("path", {
    fill: "var(--color-neutral-90)",
    d: "M26.872 67.588v4.553a2.926 2.926 0 0 1-2.825 3.081h-8.183a2.928 2.928 0 0 1-2.825-3.081v-5.124l13.833.57Z"
  }), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    d: "M88.933 36.598c0-3.03-2.862-3.828-5.123-3.536-1.267.163-2.5.519-3.66 1.054l-2.489 1.09c-1.734-3.717-4.991-9.244-7.575-11.08C67.75 22.47 61.054 21 48.04 21s-19.718 1.471-22.053 3.125c-2.548 1.786-5.753 7.232-7.51 10.943l-2.394-.9a12.354 12.354 0 0 0-3.776-1.106c-2.299-.292-5.124.505-5.124 3.536-.037 6.053 7.912 3.952 7.912 3.952-2.122 2.247-7.949 9.157-7.949 14.2 0 12.106 7.056 12.743 10.936 12.743H77.99c3.879 0 10.979-.637 10.979-12.743 0-5.043-5.856-11.953-7.956-14.236-.037.036 7.92 2.137 7.92-3.916ZM48.04 40.887c-13.665 0-26.46-.652-26.46-.652 1.962-5.277 6.083-10.43 7.32-11.506 0 0 3.476-2.686 19.133-2.686 15.656 0 19.096 2.657 19.125 2.686 1.252 1.084 5.373 6.23 7.32 11.506.021 0-9.845.652-26.438.652Z"
  }), React.createElement("path", {
    fill: "var(--color-neutral-90)",
    d: "M83.034 66.988v5.123a2.93 2.93 0 0 1-2.818 3.082h-8.19a2.928 2.928 0 0 1-2.819-3.082v-4.618l13.827-.505Z"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M12.9 67.23v5.123a2.927 2.927 0 0 0 2.84 3.11h8.168a2.927 2.927 0 0 0 2.81-3.08v-4.02"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M15.937 34.41a12.092 12.092 0 0 0-3.777-1.106c-2.29-.3-5.123.505-5.123 3.528 0 6.053 7.956 3.923 7.956 3.923C12.812 43.031 7 49.948 7 54.991c0 12.1 7.063 12.743 10.98 12.743h59.908c3.88 0 10.98-.644 10.98-12.743 0-5.043-5.856-11.96-7.957-14.236 0 0 7.956 2.13 7.956-3.923 0-3.023-2.869-3.828-5.167-3.528a12.05 12.05 0 0 0-3.66 1.054"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M77.522 35.426c-1.764-3.66-4.999-9.222-7.583-11.06-2.327-1.653-9.032-3.132-22.045-3.132-13.014 0-19.711 1.464-22.04 3.133-2.554 1.808-5.767 7.224-7.516 10.935"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M74.36 40.47c-1.962-5.27-6.09-10.423-7.32-11.506 0 0-3.461-2.687-19.125-2.687-15.663 0-19.118 2.665-19.147 2.694-1.252 1.076-5.366 6.229-7.32 11.499 0 0 12.802.651 26.46.651 16.585 0 26.452-.651 26.452-.651ZM82.895 67.23v5.123a2.965 2.965 0 0 1-2.826 3.081h-8.183a2.964 2.964 0 0 1-2.825-3.081v-4.619M57.98 67.734v-3.857a1.82 1.82 0 0 0-1.823-1.83h-16.52a1.83 1.83 0 0 0-1.83 1.83v3.857M55.147 57.004h-14.5M58.17 52.327H37.617"
  }), React.createElement("path", {
    fill: color,
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M26.242 52.349h-9.617a2.408 2.408 0 0 0-2.408 2.408v3.206a2.408 2.408 0 0 0 2.408 2.408h9.617a2.408 2.408 0 0 0 2.409-2.408v-3.206a2.408 2.408 0 0 0-2.409-2.408ZM79.17 52.349h-9.618a2.408 2.408 0 0 0-2.408 2.408v3.206a2.408 2.408 0 0 0 2.408 2.408h9.617a2.408 2.408 0 0 0 2.408-2.408v-3.206a2.408 2.408 0 0 0-2.408-2.408Z"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "m21.573 42.526 4.757 4.758M27.794 48.748l.732.732M74.638 42.526l-4.757 4.758M68.417 48.748l-.732.732"
  }), React.createElement("path", {
    stroke: "var(--color-neutral-70)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M16.471 55.189h4.392M69.17 55.189h4.392"
  }));
};
export default SvgCar;